import { ActionBus, Secret } from 'game-logic';
import { Observable, of } from 'rxjs';
import { GameBehavior, GameBehaviorActions } from './game-behavior';

export class LoadingBehavior implements GameBehavior {
  get logicVersion(): number {
    return 1;
  }
  get logicSeed(): number | undefined {
    return undefined;
  }
  get currentRoomId(): string {
    return '';
  }
  get roundDeadline(): number {
    return 0;
  }
  get behaviorActions(): ActionBus<GameBehaviorActions> {
    return this.behaviorActionBus;
  }
  get formattedReward$(): Observable<string | undefined> {
    return of(undefined);
  }
  get opponent$(): Observable<string | undefined> {
    return of(undefined);
  }
  public get opponentId$(): Observable<string | undefined> {
    return of(undefined);
  }
  public get bountyAmount$(): Observable<number | undefined> {
    return of(undefined);
  }

  private behaviorActionBus = new ActionBus<GameBehaviorActions>();

  public async startRoom(): Promise<void> {
    // Nothing
  }

  public onDestroy(): void {
    // Nothing
  }

  public async onStartNewGame(): Promise<void> {
    // Nothing
  }

  public onPauseGame(_pause: boolean): void {
    // Nothing
  }

  public onStopGame(): void {
    // Nothing
  }

  public async getInitialMoves(): Promise<string[]> {
    return [];
  }

  public getMoves(): string[] {
    return [];
  }

  public setMoves(_moves: string[]): void {
    // Nothing
  }

  public scoreChanged(_score: number): void {
    // Nothing
  }

  public async discloseSecrets(_indexes: number[]): Promise<Secret[]> {
    return [];
  }

  public async gameComplete(): Promise<void> {
    // Nothing
  }
}
